// extracted by mini-css-extract-plugin
export default {"wrapper":"warning_wrapper__cvdP-","popover":"warning_popover__SpGZY popover_popover__rwshd","icon":"warning_icon__fqF4-","focused":"warning_focused__EQLj0"};